import axios from 'axios';
// import AppConfig from "../../../../../config/AppConfig";

function getBaseURL() {
  return "https://test.usercenter.gdzawy.com/taskPoolPhp/accounting/";
}

const instance = axios.create({
  baseURL: getBaseURL() //+ '/contract/'
});

const ErrorResponse = {code: 400, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login_name = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  config.params.fingerprint = localStorage.getItem('browserFingerprint')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  })//.catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  })//.catch(error => callback(ErrorResponse))
}
export default class Http {
  static getBaseURL(){
    return getBaseURL()
  }
  static get(url, data, callback){
    get(url, data, callback)
  }
  static post(url, data, callback){
    post(url, data, callback)
  }
  static upload(url, callback){
    //实现上传文件
    let input = document.createElement('input');
    input.type = 'file';
    input.onchange = function () {
      let form = new FormData();
      form.append('file', this.files[0]);
      axios.post(getBaseURL()+url,form).then(res=>{
        callback(res.data.data)
      })
    }
    input.click();
  }
  static uploadFile(callback){
    __OSS__.setBucket("gdza").uploadFile(data=>{
      let path_arr=(data.path||"").split('/')
      callback({
        name:path_arr[path_arr.length-1],
        path:data.path
      })
    });
  }
  static uploadFile2(callback){
    __OSS__.setBucket("gdza").uploadFile(data=>{
      let path_arr=(data.path||"").split('/');
      let file_name=path_arr[path_arr.length-1];
      __OSS__.setXscFile(file_name,data.path,callback)
    });
  }
  static enUrl(url){
    let login = localStorage.getItem('login')
    let token = localStorage.getItem('token')
    let fingerprint = localStorage.getItem('browserFingerprint')
    if(url.indexOf('http')!==-1){
      return url;
    }else {
      if(url.indexOf("?")===-1){
        return getBaseURL()+url+`?login=${login}&token=${token}&fingerprint=${fingerprint}`
      }else {
        return getBaseURL()+url+`&login=${login}&token=${token}&fingerprint=${fingerprint}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/FinancialCenter/common/Http.js